import { GitMergeIcon } from 'lucide-react';

import { SplitButton, SplitButtonPrimary } from '@/components/ui/split-button';

// TODO: implement revert flow
export function MergedIndicator() {
  return (
    <SplitButton variant="outline">
      <SplitButtonPrimary disabled>
        <GitMergeIcon className="size-4 text-indigo-700" />
        Merged
      </SplitButtonPrimary>
    </SplitButton>
  );
}
